import { useContext, useEffect } from 'react';

import { ThemeContext } from './ThemeProvider';
import type { ResolvedTheme } from './themeTypes';

export function useTheme() {
  const context = useContext(ThemeContext);

  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }

  return context;
}

export function useThemeRouteOverride(theme: ResolvedTheme) {
  const context = useContext(ThemeContext);

  useEffect(() => {
    if (!context) {
      return undefined;
    }

    context.setRouteThemeOverride(theme);

    return () => {
      context.clearRouteThemeOverride();
    };
  }, [context, theme]);
}
